"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.giveBadgeToMemberById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Gives an existing badge to an existing member.
 *
 * Badge is identified by its stringified `ObjectID`.
 * Member is identified by their Discord ID.
 *
 * ## Usage
 *
 * ```ts
 * const badgeId: string = "567678d96778a6876cc78";
 * const memberId: string = "2938274356793";
 *
 * const {
 * 	acknowledged,
 *  insertedId,
 * } = await sdk.giveBadgeToMemberById({ badgeId, memberId });
 * ```
 *
 * @param params.badgeId  - ID of the badge to give to selected member.
 * @param params.memberId - ID of member which is supposed to get a badge.
 */
const giveBadgeToMemberById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { badgeId, memberId } = params;
    const url = `${BASE_URL}/members/member/${memberId}/badges/badge/${badgeId}`;
    const memberBadgeResponse = yield axios_1.default.post(url, {}, { validateStatus: () => true });
    const { status, data } = memberBadgeResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.giveBadgeToMemberById = giveBadgeToMemberById;
